import {DeleteIcon} from '../../ui-components/Iconpack';
import * as React from 'react';
import {MediaFolder} from '../../reducers/media';
import {StorageSourceCrud} from '../../api/org/storageSource/api';
import {toast} from 'react-toastify';

type LoadingState = 'init' | 'pending' | 'fulfilled' | 'rejected';

export function DeleteFolder(props: {
    folder: MediaFolder;
    onFolderDelete: (folder: MediaFolder) => void;
    storageSourceCrud: StorageSourceCrud | undefined;
}) {
    const [loading, setLoading] = React.useState<LoadingState>('init');

    const onDelete = (folder: MediaFolder) => {
        if (loading !== 'init') return;
        setLoading('pending');
        const currentId = toast(`Deleting folder ${folder.name}`, {
            type: 'info',
            autoClose: false,
            position: 'top-right',
        });
        props.storageSourceCrud
            ?.delete(folder.name)
            .then(() => {
                toast.dismiss(currentId);
                toast(`Folder "${folder.name}" deleted`, {type: 'success', position: 'top-right', autoClose: 3000});
                setLoading('fulfilled');
                props.onFolderDelete(folder);
            })
            .catch((err) => {
                toast.dismiss(currentId);
                toast(`Failed to delete folder "${folder.name}": ${err}`, {type: 'error', autoClose: 3000});
                setLoading('rejected');
            })
            .then(() => {
                setLoading('init');
            });
    };

    const onClick = () => {
        const confirm = window.confirm(`Are you sure you want to delete the folder "${props.folder.name}"?`);
        if (confirm) {
            const confirm2 = window.confirm(`Are you really sure? This action is irreversible.`);
            if (confirm2) {
                onDelete(props.folder);
            }
        }
    };
    return (
        <div
            data-disabled={loading !== 'init'}
            className={'cursor-pointer data-[disabled=true]:animate-pulse data-[disabled=true]:cursor-wait'}
            onClick={onClick}>
            <DeleteIcon />
        </div>
    );
}
